<template>
  <div>
    <div class="minorTitle">
      Payment Methods
    </div>

    <p>
      Payment is needed on or before {{ currentInvoice.payment_due_date }}.&nbsp;&nbsp;<span
        v-if="currentInvoice.past_due"
        class="minorTitle colorError"
      >Payment is past due.</span>
      <br><br>
      Select your preferred payment method from the list of available options below.
    </p>

    <!-- they can pay by credit card -->
    <div v-if="currentInvoice.can_pay_by_cc">
      <!-- cc or debit card -->
      <div class="row paddingSmallBottom">
        <div class="one columns">
          <input
            id="pay_by_cc"
            v-model="currentPaymentMethod"
            class="hiddenInput quoteApproval"
            name="pay_by_cc"
            value="pay_by_cc"
            type="radio"
          >
          <label
            for="pay_by_cc"
            class="radioCheckboxOutline"
          >
            <div class="radioCheckbox">
              <div class="radioCheck" />
            </div>
          </label>
        </div>
        <div class="eleven columns">
          Credit or Debit Card
        </div>
      </div>
		  
      <!-- cc or debit card is selected -->
      <div :class="{ hidden: currentPaymentMethod != 'pay_by_cc'}">
        <!-- they can not pay by cc -->
        <div v-if="!currentInvoice.can_pay_by_cc">
          The invoice can not be paid with a credit/debit card for the following reason(s):
          <ul>
            <li
              v-for="message in currentInvoice.cc_pay_message"
              :key="message"
            >
              {{ message }}
            </li>
          </ul>
        </div>  

        <!-- they CAN pay by cc -->
        <div
          v-else
          class="payInvoiceForm row"
        >
          <div class="one column">
						&nbsp;
          </div>
          <div class="eleven columns backgroundColorDimmer paddingNormal marginNormalBottom">
            <!-- they have cards and the add card form is not being displayed -->
            <div v-if="cards.length > 0 && !isCardFormVisible">
              <p>
                Please select an existing card or add a new one to proceed with payment.
              </p>

              <div class="row">
                <div class="eight columns">
                  <label class="flexGrow paddingNormalRight">
                    <select
                      v-model="selected"
                      name="creditCard"
                    >
                      <option
                        disabled
                        value=""
                      >Please select a card</option>
                      <option :value="'add_card'">Add a New Card</option>
                      <option
                        v-for="card in cards"
                        :key="card.id"
                        :value="card.id"
                      >{{ card.type }} - {{ card.last_four }} {{ card.expire_month }}/{{ card.expire_year }}</option>
                    </select>
                  </label>
                </div>
                <div class="four columns">
                  <button
                    v-if="typeof (apiPending.pay_invoice) !== 'undefined'"
                    class="disabledButton bidButton u-full-width"
                    disabled="disabled"
                  >
                    <span class="loading" />
                  </button>
                  <button
                    v-else
                    type="submit"
                    class="bidButton backgroundColorDefault u-full-width"
                    @click="submitPayment('pay_invoice')"
                  >
                    Pay Invoice
                  </button>
                </div>
              </div>

              <ApiResponse :context="'pay_invoice'" />
            </div>

            <!-- they do not have cards OR the add card form is being displayed -->
            <div
              v-if="cards.length === 0 || isCardFormVisible"
              class="creditCardForm"
            >
              <CreditCardForm
                :card-values="Card"
                @updateCard="setCard"
              />

              <ApiResponse :context="'add_card'" />

              <div class="flexBoxSpread">
                <button
                  v-if="typeof (apiPending.add_card) !== 'undefined'"
                  class="disabledButton bidButton u-full-width"
                  disabled="disabled"
                >
                  <span class="loading" />
                </button>
                <button
                  v-else
                  type="submit"
                  class="bidButton backgroundColorDefault u-full-width"
                  @click="addCard('add_card')"
                >
                  Pay Invoice
                </button>
                <span
                  class="cancelButton"
                  @click="hideCardForm"
                >
                  Cancel
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- wire transfer -->
    <div class="row paddingSmallBottom">
      <div class="one columns">
        <input
          id="pay_by_wire"
          v-model="currentPaymentMethod"
          class="hiddenInput quoteApproval"
          name="pay_by_wire"
          value="pay_by_wire"
          type="radio"
        >
        <label
          for="pay_by_wire"
          class="radioCheckboxOutline"
        >
          <div class="radioCheckbox">
            <div class="radioCheck" />
          </div>
        </label>
      </div>
      <div class="eleven columns">
        Wire Transfer
      </div>
    </div>

    <div
      v-if="currentPaymentMethod == 'pay_by_wire'"
      class="row"
    >
      <div class="one column">
				&nbsp;
      </div>
      <div class="eleven columns backgroundColorDimmer paddingNormal marginNormalBottom">
        <p>
          To pay this invoice by Wire Transfer, send the total amount due via an electronic funds transfer with the following information.
        </p>
        <blockquote>
          Payee - Leland Little Auctions<br>
          Bank - Truist Bank<br>
          Bank Address - 351 South Churton Street, Hillsborough, NC 27278 USA<br>
          Bank Phone - (919) 644-7802<br>
          Account Number - 1340004390562<br>
          ABA Routing Number - 053101121<br>
          Swift Number - BRBTUS33<br>
          Include the following text - "{{ customer.display_name }} - Invoice #{{ currentInvoice.invoice_id }}"<br>
        </blockquote>
      </div>
    </div>
      
    <!-- they can pay by credit card, and, therefore, paypal -->
    <div v-if="currentInvoice.can_pay_by_cc">
      <!-- paypal -->
      <div class="row paddingSmallBottom">
        <div class="one columns">
          <input
            id="pay_by_paypal"
            v-model="currentPaymentMethod"
            class="hiddenInput quoteApproval"
            name="pay_by_wire"
            value="pay_by_paypal"
            type="radio"
          >
          <label
            for="pay_by_paypal"
            class="radioCheckboxOutline"
          >
            <div class="radioCheckbox">
              <div class="radioCheck" />
            </div>
          </label>
        </div>
        <div class="eleven columns">
          Paypal
        </div>
      </div>

      <!-- they have selected paypal -->
      <div
        v-if="currentPaymentMethod == 'pay_by_paypal'"
        class="row"
      >
        <div class="one column">
					&nbsp;
        </div>
        <div class="eleven columns backgroundColorDimmer paddingNormal marginNormalBottom">
          <!-- they can not pay by paypal -->
          <div v-if="!currentInvoice.can_pay_by_cc">
            The invoice can not be paid via PayPal for the following reason(s):
            <ul>
              <li
                v-for="message in currentInvoice.paypal_pay_message"
                :key="message"
              >
                {{ message }}
              </li>
            </ul>
          </div>

          <!-- they CAN pay by paypal -->
          <div v-else>
            <p>
              To pay this invoice through PayPal, transfer the total amount due to the PayPal account:
            </p>
            <p>
              info@llauctions.com
            </p>
            Please include this invoice number #{{ currentInvoice.invoice_id }} in the notes of the PayPal payment.  Payments made through PayPal can take up to 1 business day to be reflected in your Leland Little online account.
          </div>
        </div>
      </div>
    </div>

    <!-- check -->
    <div class="row paddingSmallBottom">
      <div class="one columns">
        <input
          id="pay_by_check"
          v-model="currentPaymentMethod"
          class="hiddenInput quoteApproval"
          name="pay_by_wire"
          value="pay_by_check"
          type="radio"
        >
        <label
          for="pay_by_check"
          class="radioCheckboxOutline"
        >
          <div class="radioCheckbox">
            <div class="radioCheck" />
          </div>
        </label>
      </div>
      <div class="eleven columns">
        Check 
      </div>
    </div>

    <div
      v-if="currentPaymentMethod == 'pay_by_check'"
      class="row"
    >
      <div class="one column">
				&nbsp;
      </div>
      <div class="eleven columns backgroundColorDimmer paddingNormal marginNormalBottom">
        <p>
          To pay this invoice by Cashier's Check, Personal Check, or Business Check, please make the check out to LELAND LITTLE AUCTIONS, LTD. for the total amount due and mail to: 
        </p>
        <p>
          Leland Little Auctions<br>
          620 Cornerstone Court<br>
          Hillsborough, NC 27278 
        </p>
        When paying by Personal or Business Check, we reserve the right to hold the item(s) for 7 business days after receiving the check, or until the check has cleared; whichever is greater.
      </div>
    </div>
  </div>
</template>

<script>
import ApiResponse from '@/components/ApiResponse'
import CreditCardForm from '@/components/Forms/CreditCardForm'

export default {
  name: 'PayInvoice',
  components: {
    CreditCardForm,
	ApiResponse
  },
  props: [
    'invoice_id',
    'amount'
  ],
  data () {
    return {
      selected: '',
      currentPaymentMethod: '',
      'Card': {
        'card_number': '',
        'expire_month': '',
        'expire_year': '',
        'cvv2': '',
        'billing_address': '',
        'billing_zip': ''
      }
    }
  },
  computed: {
    cards: function () {
      return this.$store.getters.customerCreditCards
    },
    isCardFormVisible: function () {
      return this.$store.getters.payInvoiceModalIsCardFormVisible
    },
    currentInvoice: function() {
        return this.$store.getters.invoices['INVOICEID_' + this.$store.getters.currentInvoice]
    },
	customer: function () {
		return this.$store.getters.customer
	},
	apiPending: function () {
      return this.$store.getters.apiPending
    }
  },
	watch: {
		selected: function () {
			if(this.selected === 'add_card'){
				this.showCardForm()
			}
		}		
		
	},
  methods: {
    showCardForm () {
      this.$store.dispatch('clearApiResponse')
      this.$store.dispatch('showPayInvoiceCardForm')
    },
    hideCardForm () {
      this.$store.dispatch('clearApiResponse')
      this.$store.dispatch('hidePayInvoiceCardForm')
    },
    addCard (context) {
      const payload = {
        'card': {
          'card_number': this.Card.card_number,
          'expire_month': this.Card.expire_month,
          'expire_year': this.Card.expire_year,
          'cvv2': this.Card.cvv2,
          'billing_address': this.Card.billing_address,
          'billing_zip': this.Card.billing_zip,
          'country': this.Card.country
        },
		'context': context
      }
      this.$store.dispatch('addCard', payload)
    },
    submitPayment (context) {
      let payload = {
        'invoice_ids': [this.invoice_id],
        'amount': this.amount,
        'credit_card_id': this.selected,
        'context': context
      }
      this.$store.dispatch('payInvoice', payload)
    },
    setCard: function (cardValues) {
      this.Card = cardValues
    }
  }
}

</script>

<style scoped>

</style>
